
const _ = require('lodash');
const ko = require('knockout');
const $ = require('jquery');


function isScrolledTo ($elem, $container) {
	const elemOffset = $elem.offset();
	if (!elemOffset) {
		return false;
	}

	const contHeight = $container.height();

	const elemTop = elemOffset.top - $container.offset().top;
	const elemBottom = elemTop + $elem.height();

	return elemTop >= 0 && elemBottom <= contHeight;
}

function scrollImmidiate ($elem, $container) {
	if (!isScrolledTo($elem, $container)) {
		$elem.velocity('scroll', {
			container: $container,
			duration: 0,
		});
	}
}

function scrollAnimated ($elem, $container) {
	if (!isScrolledTo($elem, $container)) {
		$elem.velocity('scroll', {
			container: $container,
		});
	}
}

function findChildThatShouldBeVisible ($element, valueAccessor, allBindings) {
	const dataThatShouldBeVisible = ko.unwrap(valueAccessor());

	let key = _.identity;
	if (allBindings.has('foreachScrollToKey')) {
		const k = ko.unwrap(allBindings.get('foreachScrollToKey'));
		key = _.isString(k) ? _.property(k) : k;
	}

	// TODO: there probably is a better way to find the element of interest
	const childThatShouldBeVisible = _.find($element.children(), (child) => {
		return key(ko.dataFor(child)) === dataThatShouldBeVisible;
	});

	return $(childThatShouldBeVisible);
}

// useful with foreach to keep an element visible in a parent with scrollbar
ko.bindingHandlers.foreachScrollTo = {
	after: ['foreach'],
	init: function (element, valueAccessor, allBindings) {
		const $element = $(element);

		ko.computed(function () {
			// eslint-disable-next-line no-unused-vars
			const newForeachValue = ko.unwrap(allBindings.get('foreach')); // register dependency

			const $child = ko.ignoreDependencies(() => {
				return findChildThatShouldBeVisible($element, valueAccessor, allBindings);
			});

			scrollImmidiate($child, $element);
		});
	},
	update: function (element, valueAccessor, allBindings) {
		const $element = $(element);

		if (!_.includes(['relative', 'absolute', 'fixed'], $element.css('position'))) {
			console.warn('For velocity scroll to work, the container must have'
						 + ' position relative, absolute, or fixed', element);
		}

		const $child = findChildThatShouldBeVisible($element, valueAccessor, allBindings);

		scrollAnimated($child, $element);
	},
};
